import * as React from 'react'
import { Box, TableCell, TableRow } from '@material-ui/core'
import { JsonEditor } from '../../../ui/JsonEditor'

interface MarketplaceListingPropsEditorProps {
  value: string
  onChange: (value: string) => void
}

export const MarketplaceListingPropsEditor: React.FC<MarketplaceListingPropsEditorProps> = ({ value, onChange }) => {
  return (
    <TableRow>
      <TableCell style={{ width: 200, minWidth: 200, whiteSpace: 'nowrap' }}>Properties JSON</TableCell>
      <TableCell style={{ width: '100%', maxWidth: 0 }}>
        <Box width='100%' style={{ overflowX: 'auto' }}>
          <JsonEditor value={value} onChange={onChange} height='260px' />
        </Box>
      </TableCell>
    </TableRow>
  )
}
